import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../../UserInfo";
import { inserirOuAtualizar, criarParametrosLivroDiat } from "../../../DataSources";
import ShowError from "../../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  titulo: "",
  formula: "",
  descricao: "",
};

export default class ParametrosLivroForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.parametrosLivroDs = criarParametrosLivroDiat();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.parametrosLivroDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (!data) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/parametros_livro_diat");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ...template });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2} labelLocation="top">
            <GroupItem
              caption="PARÂMETROS LIVRO DA DÍVIDA ATIVA"
              colSpan={2}
              colCount={6}
            >
              <SimpleItem dataField={"codigo"} colSpan={2}>
                <Label text="Código" />
              </SimpleItem>
              <SimpleItem dataField={"numero"} colSpan={2}>
                <Label text="Número" />
              </SimpleItem>
              <SimpleItem
                dataField={"dataLei"}
                colSpan={2}
                editorType={"dxDateBox"}
                editorOptions={{ editorType: "date", width: "100%" }}
              >
                <Label text="Data da Lei" />
              </SimpleItem>
              <SimpleItem dataField={"titulo"} colSpan={3}>
                <Label text="Título" />
              </SimpleItem>
              <SimpleItem dataField={"fundamento"} colSpan={3}>
                <Label text="Fundamento" />
              </SimpleItem>
              <SimpleItem dataField={"diretor"} colSpan={3}>
                <Label text="Diretor" />
              </SimpleItem>
              <SimpleItem dataField={"cargoDiretor"} colSpan={3}>
                <Label text="Cargo do Diretor" />
              </SimpleItem>
              <SimpleItem dataField={"secretario"} colSpan={3}>
                <Label text="Secretario" />
              </SimpleItem>
              <SimpleItem dataField={"cargoSecretario"} colSpan={3}>
                <Label text="Cargo do Secretario" />
              </SimpleItem>
              <SimpleItem
                dataField={"obs"}
                editorType={"dxTextArea"}
                colSpan={6}
              >
                <Label text="Descrição" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancel} width={120} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.parametrosLivroDs, entidade)
      .then(
        function () {
          _cadastroCorrente = undefined;
          _cancelando = true;
          notify("Fórmula cadastrada com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
